export const EMAIL = /\S+@\S+\.\S+/;

export const PASSWORD_12Ch_1Up_1Low_1Num = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{12,})/;
